import React, { useEffect, useState, useCallback } from "react";
import Networks from "../../components/shared/resources-list/Networks";
import {
  convertArrayToDropDownList,
  toggleArrayItem,
} from "../../app_shared_functions";
import OnlyIPv6 from "../servers/create/network/OnlyIPv6";
import Suggestion from "../servers/create/network/Suggestion";
import NoNetworks from "../servers/create/network/NoNetworks";
import { Loader } from "semantic-ui-react";
import { useSelector } from "react-redux";
import useSubscribe from "../../custom-hooks/useSubscribe";
import { NetworksListProps, Network } from "./types";

const NetworksList: React.FC<NetworksListProps> = ({
  region,
  selectedNetworks = [],
  handleChange,
  isRequired,
  disabled,
}) => {
  const [networks, setNetworks] = useState<Network[] | undefined>(undefined);
  const allNetworks = useSelector(
    (state: any) => state.networks.NETWORKS_LIST,
  ) as Record<string, Network>;

  useSubscribe("NETWORKS_LIST");

  const updateList = useCallback(
    (id: string) => {
      handleChange({
        name: "selectedNetworks",
        value: toggleArrayItem(selectedNetworks, id),
      });
    },
    [selectedNetworks, handleChange],
  );

  useEffect(() => {
    const list = Object.values(allNetworks || {}).filter(
      (network) =>
        network.region.toLowerCase() === region.toLowerCase() &&
        !network["router:external"],
    );

    if (JSON.stringify(list) !== JSON.stringify(networks)) {
      setNetworks(list);

      if (list.length === 1 && !selectedNetworks.includes(list[0].id)) {
        handleChange({
          name: "selectedNetworks",
          value: [list[0].id],
        });
      }
    }
  }, [region, allNetworks, networks, selectedNetworks, handleChange]);

  if (networks === undefined) {
    return (
      <div className="loader-wrapper">
        <Loader size="mini" active className="one-liner">
          Fetching Network list...
        </Loader>
        <div className="separator width-100p padding-top-30 padding-bottom-30" />
      </div>
    );
  }

  return (
    <>
      <Networks
        title="Networks"
        className="select-box full"
        disabled={networks?.length === 0 || disabled}
        selectedNetworkList={selectedNetworks}
        loading={false}
        networks={convertArrayToDropDownList(networks)}
        update={updateList}
        as="multiselect"
        isRequired={isRequired}
      />
      <NoNetworks networks={networks} region={region} />
      <OnlyIPv6
        selectedNetworkList={selectedNetworks}
        networks={networks || []}
      />
      <Suggestion
        selectedNetworkList={selectedNetworks}
        networks={networks || []}
      />
    </>
  );
};

export default NetworksList;
